import { render, staticRenderFns } from "./TrendingSessions.vue?vue&type=template&id=f82b4894&scoped=true"
import script from "./TrendingSessions.vue?vue&type=script&lang=js"
export * from "./TrendingSessions.vue?vue&type=script&lang=js"
import style0 from "./TrendingSessions.vue?vue&type=style&index=0&id=f82b4894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f82b4894",
  null
  
)

export default component.exports